/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { Container, Row } from 'react-bootstrap';
import { difference } from 'lodash';
import BtnAdd from '../../../../Components/Utility/FilterAction/BtnAdd';
import BtnDelete from '../../../../Components/Utility/FilterAction/BtnDelete';
import BtnSelectAll from '../../../../Components/Utility/FilterAction/BtnSelectAll';
import BtnBack from '../../../../Components/Utility/FilterAction/BtnBack';
import SearchBar from '../../../../Components/Utility/FilterAction/SearchBar';
import BinFolder from './binFolder';
import Loader from '../../../../Components/Utility/Loader/Loader';
import DamFolderGroupCard from '../../../../Components/Card/DamFolderGroupCard/DamFolderGroupCard';
import {
  deleteDamFolderGroupByIdAction,
  fetchDamFolderGroupList,
  archiveUnarchiveFolders,
  fetchDamAcrhivedFolder,
  fetchDamDeletedFolders,
  filterFolderSortData,
} from '../store/DamFolder.action';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import { Page_Size } from '../../../../Components/helper';
import ArchivedFolder from './ArchivedFolder';
import { useDamFolderModuleState } from '../Provider';

const damPath = '/digital-assets-management';

const damFolderPath = '/digital-assets-management/folder';

const btnActiveClass = 'btn-active';

function DamFolderList() {
  const location = useLocation();
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const history = useHistory();
  const { DamFolderstate, setDamFolderState, damAddEditAccess, damDeleteAccess } = useDamFolderModuleState([]);
  const { selectedIdArray, archivedList } = DamFolderstate;

  const [isSelectAll, setSelectAll] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [selectedBomLibraryGroupId, setBomId] = useState(null);
  const [showFilterMobile, setFilterMobile] = useState(false);
  const {
    damFolderData: {
      damFolderGroupList,
      totalCount,
      filterValues: { pageIndex, pageSize, searchText, loading },
    },
    UserDetails: {
      userInfo: { userId },
    },
  } = useSelector((reduxState) => reduxState);

  const [state, setState] = useState({
    damFolderGroupList: [],
    hasMore: true,
    loading: true,
    totalRecords: null,
    searchText: '',
    searchLoaded: false,
    archiveIds: [],
    activeAcrhiveModal: false,
    isArchiveState: false,
    archivedComment: '',
    activeList: 'folder',
    archivedList: [],
    binList: [],
  });
  const { activeAcrhiveModal, archivedComment } = state;

  useEffect(() => {
    setState((inInfinitestate) => ({
      ...inInfinitestate,
      loading,
    }));
  }, [loading]);

  useEffect(() => {
    if (Array.isArray(damFolderGroupList)) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        damFolderGroupList,
      }));
    }
  }, [damFolderGroupList]);

  useEffect(() => {
    if (location?.state?.archived) {
      setState((prevData) => ({
        ...prevData,
        activeList: 'archivedFolder',
      }));
    }
  }, [location?.state?.archived]);

  useEffect(() => {
    if (totalCount > damFolderGroupList?.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [damFolderGroupList?.length, totalCount]);

  const buildParams = (data) => {
    const params = {
      pageIndex: data.pageIndex,
      pageSize: data.pageSize,
    };
    if (searchText) {
      params.searchText = searchText;
    }
    params.isScrolled = data.isScrolled;
    return params;
  };

  const getDamFolderGroupList = async (data) => {
    setState((toGetstate) => ({
      ...toGetstate,
      loading: true,
      ...data,
    }));

    const params = buildParams(data);
    await dispatch(fetchDamFolderGroupList(params));
    setState((inInfinitestate) => ({
      ...inInfinitestate,
      loading: false,
    }));
  };

  const handlePageNextInScroll = async () => {
    let index = pageIndex;
    index += 1;
    const params = {
      pageIndex: index,
      pageSize,
      searchText,
      totalRecords: totalCount,
      isScrolled: true,
    };
    const obj = {
      pageIndex: index,
      pageSize,
    };
    await dispatch(filterFolderSortData(obj));
    await getDamFolderGroupList(params);
  };

  useEffect(() => {
    const callFn = async () => {
      const params = {
        pageIndex,
        pageSize,
      };
      setState((prevState) => ({ ...prevState, loading: true }));
      batch(async () => {
        const response = await getDamFolderGroupList(params);
        if (response) setState((prevState) => ({ ...prevState, loading: false }));
      });
    };
    if (userId) callFn();
    return () => {
      const obj = {
        pageIndex: 1,
        searchText: '',
      };
      dispatch(filterFolderSortData(obj));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, userId]);

  const handleSelectAll = () => {
    if (isSelectAll) {
      setDamFolderState((prev) => ({ ...prev, selectedIdArray: [] }));
    } else {
      const selectedItems = [...selectedIdArray];
      // eslint-disable-next-line no-restricted-syntax
      if (state.activeList === 'archivedFolder') {
        for (const item of archivedList) {
          const findItems = selectedItems.filter((val) => val === item._id);
          if (findItems.length === 0) {
            selectedItems.push(item._id);
          }
        }
      } else {
        for (const item of state.damFolderGroupList) {
          const findItems = selectedItems.filter((val) => val === item._id);
          if (findItems.length === 0) {
            selectedItems.push(item._id);
          }
        }
      }
      setDamFolderState((prev) => ({ ...prev, selectedIdArray: selectedItems }));
    }
    setSelectAll(!isSelectAll);
  };

  const refreshPage = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
      pageIndex: 1,
      damFolderGroupList: [],
      totalRecords: null,
      hasMore: true,
      searchText: '',
      searchLoaded: false,
    }));
    setDamFolderState((prev) => ({ ...prev, selectedIdArray: [] }));
    setBomId(null);
    setSelectAll(false);
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      damFolderGroupList: [],
      totalRecords: null,
      isSelectAll: false,
      selectedIdArray: [],
    };
    if (location?.state?.activeList === 'archivedFolder') {
      await dispatch(fetchDamAcrhivedFolder(params));
    } else {
      await getDamFolderGroupList(params);
    }
  };

  const onSelectCheckBox = async (e, id) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems.filter((item) => item === id);
    if (findItems.length > 0) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setDamFolderState((prev) => ({ ...prev, selectedIdArray: selectedItems }));
    } else {
      setDamFolderState((prev) => ({ ...prev, selectedIdArray: [...selectedItems, id] }));
    }
  };

  const deleteDamFolderGroup = (id) => {
    setBomId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const deleteById = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    const params = {};
    if (selectedBomLibraryGroupId) {
      params.damGroupId = [selectedBomLibraryGroupId];
    } else {
      params.damGroupId = [...selectedIdArray];
    }
    const res = await dispatch(deleteDamFolderGroupByIdAction(params, t));
    if (res) {
      setShowConfirmationPopup(!showConfirmationPopup);
      refreshPage();
    } else {
      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  useEffect(() => {
    if (state.activeList === 'folder' && state.damFolderGroupList.length > 0) {
      const stateIds = state.damFolderGroupList.map((item) => item._id);
      const selectedItems = [...selectedIdArray];
      const unSelectedItems = difference(stateIds, selectedItems);
      if (unSelectedItems.length > 0) {
        setSelectAll(false);
      } else {
        setSelectAll(true);
      }
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIdArray, state.activeList]);

  useEffect(() => {
    if (state.activeList === 'archivedFolder' && state.archivedList.length > 0) {
      const stateIds = state.archivedList.map((item) => item._id);
      const selectedItems = [...selectedIdArray];
      const unSelectedItems = difference(stateIds, selectedItems);
      if (unSelectedItems.length > 0) {
        setSelectAll(false);
      } else {
        setSelectAll(true);
      }
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIdArray, state.activeList]);

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((prev) => ({
      ...prev,
      searchLoaded: true,
    }));
    const obj = {
      searchText: targetValue,
      pageIndex: 1,
      pageSize: Page_Size,
      loading: true,
    };
    await dispatch(filterFolderSortData(obj));
  };

  const closeAcrhiveTrashDeleteModal = () => {
    setState((prev) => ({
      ...prev,
      activeAcrhiveModal: false,
      archiveIds: [],
    }));
  };

  const handleArchivedUnarchivedConfirmed = async () => {
    const params = { isArchived: state?.activeList === 'folder', archivedComment };
    if (selectedBomLibraryGroupId) {
      params.folderIds = [selectedBomLibraryGroupId];
    } else {
      params.folderIds = [...selectedIdArray];
    }
    const res = await dispatch(archiveUnarchiveFolders(params, t));
    if (res) {
      setState((prev) => ({
        ...prev,
        activeAcrhiveModal: false,
        archivedComment: '',
        archiveIds: [],
      }));
      refreshPage();
    } else {
      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        setState((prev) => ({
          ...prev,
          hasMore: true,
        }));
        setDamFolderState((prev) => ({ ...prev, selectedIdArray: [] }));
        setBomId(null);
        setSelectAll(false);
        const params = {
          pageIndex,
          pageSize,
          searchText,
        };
        const obj = {
          pageIndex: 1,
          pageSize: Page_Size,
          searchText,
        };
        if (location.state.activeList === 'bin') {
          await dispatch(fetchDamDeletedFolders(params));
        }
        if (location.state.activeList === 'folder') {
          await dispatch(fetchDamFolderGroupList(params));
        }
        if (location.state.activeList === 'archivedFolder') {
          await dispatch(fetchDamAcrhivedFolder(params));
        }
        await dispatch(filterFolderSortData(obj));
        const afterApiCAllObj = {
          loading: false,
        };
        await dispatch(filterFolderSortData(afterApiCAllObj));
        setState((prev) => ({
          ...prev,
          searchLoaded: false,
        }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const archiveUnArchivedFn = (item) => {
    setState((prev) => ({
      ...prev,
      activeAcrhiveModal: !state?.isArchivedModal,
    }));
    setBomId(item);
  };

  const onFolderClick = async () => {
    history.push(damFolderPath, { activeList: 'folder' });
    setState((prevData) => ({
      ...prevData,
      activeList: 'folder',
      isArchiveState: false,
    }));

    setDamFolderState((prev) => ({ ...prev, selectedIdArray: [] }));
    setSelectAll(false);

    const obj = {
      searchText: '',
    };
    await dispatch(filterFolderSortData(obj));

    const params = {
      pageIndex: 1,
      pageSize,
      isScrolled: false,
    };
    await getDamFolderGroupList(params);
  };

  const onOpenClick = async () => {
    history.push(damPath, { archived: false, activeList: 'open' });
    setState((prevData) => ({
      ...prevData,
      activeList: 'open',
    }));

    const obj = {
      searchText: '',
    };
    await dispatch(filterFolderSortData(obj));

    const params = {
      pageIndex: 1,
      pageSize,
      damFolderGroupList: [],
      totalRecords: state.totalRecords,
      searchText,
      archived: false,
      isScrolled: false,
    };
    await getDamFolderGroupList(params);
  };

  const onArchivedAssetClick = () => {
    history.push(damPath, { archived: true, activeList: 'archived' });
    setState((prevData) => ({
      ...prevData,
      activeList: 'archived',
    }));
    const obj = {
      pageIndex: 1,
      searchText: '',
    };
    dispatch(filterFolderSortData(obj));
  };

  const onArchivedFolderClick = () => {
    setState((prevData) => ({
      ...prevData,
      activeList: 'archivedFolder',
      isArchiveState: true,
    }));
    history.push(damFolderPath, { archived: true, activeList: 'archivedFolder' });
    const obj = {
      pageIndex: 1,
      searchText: '',
    };
    dispatch(filterFolderSortData(obj));
    setDamFolderState((prev) => ({ ...prev, selectedIdArray: [] }));
    setSelectAll(false);
  };

  const onBackClick = async () => {
    history.push(damPath);
  };

  useEffect(() => {
    setState((inInfinitestate) => ({
      ...inInfinitestate,
      loading,
    }));
  }, [loading]);

  const handleBinClick = () => {
    setState((prevData) => ({
      ...prevData,
      activeList: 'bin',
    }));
    history.push(damFolderPath, { activeList: 'bin' });
  };

  useEffect(() => {
    if (state?.activeList === 'folder' && state?.damFolderGroupList?.length > 0 && isSelectAll) {
      const selectedItems = [...selectedIdArray];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of state.damFolderGroupList) {
        const findItems = selectedItems.filter((val) => val === item._id);
        if (findItems.length === 0) {
          selectedItems.push(item._id);
        }
      }
      setDamFolderState((prev) => ({ ...prev, selectedIdArray: selectedItems }));
    }
  }, [state?.damFolderGroupList, isSelectAll]);

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('DAM_FOLDER_VIEW.LISTING_VIEW.DIGITAL_ASSET_FOLDER')}</h4>
        </div>
        <div className="search-filter">
          {selectedIdArray?.length > 0 && (
            <span className="d-none d-md-inline-block  f-14 mr-4">
              {selectedIdArray?.length}
              {t('DAM_MAIN_VIEW.LISTING_VIEW.FOLDER_SELECTED')}
            </span>
          )}
          <SearchBar onSearch={handleSearch} value={searchText} placeholder={t('DAM_FOLDER_VIEW.LISTING_VIEW.SEARCH_FOLDER')} />
          <div className="web-filter">
            {state.activeList === 'folder' && damAddEditAccess && (
              <Link className="cursor-pointer text-dark text-decoration-none" to="/digital-assets-management/folder/add">
                <BtnAdd addEditAccess={damAddEditAccess} />
              </Link>
            )}

            {state.activeList === 'archivedFolder' && damDeleteAccess && (
              <span title="Bin" className="cursor-pointer">
                <BtnDelete
                  title="Bin"
                  multiDelete={() => {
                    deleteDamFolderGroup(null);
                  }}
                  isDisabled={selectedIdArray.length <= 0}
                />
              </span>
            )}
            {state.activeList !== 'bin' && damAddEditAccess && (
              <>
                <span title={location?.state?.activeList === 'folder' ? 'Archive' : 'Unarchive'} className="cursor-pointer">
                  <button
                    aria-label={location?.state?.activeList === 'folder' ? 'Archive' : 'Unarchive'}
                    disabled={selectedIdArray?.length === 0}
                    onClick={() => archiveUnArchivedFn(null)}
                    className="filter-btn filter-button_add"
                  >
                    <i className="icon-server" />
                  </button>
                </span>
                <BtnSelectAll handleSelectAll={handleSelectAll} isSelectAll={isSelectAll} />
              </>
            )}
            {state.activeList === 'archivedFolder' && damAddEditAccess && (
              <button type="button" className="filter-btn filter-button_selectall btn-bin" onClick={() => handleBinClick()}>
                {t('DAM_MAIN_VIEW.LISTING_VIEW.BIN')}
              </button>
            )}
            <BtnBack backTriggered={onBackClick} />
          </div>
          {damAddEditAccess && (
            <button type="button" onClick={() => setFilterMobile(!showFilterMobile)} className="filter-btn btn-mobile-more">
              <i className="icon-new-more" />
            </button>
          )}
        </div>
        <div className={showFilterMobile ? 'mobile-filter open' : 'mobile-filter'}>
          <Link className="cursor-pointer text-dark text-decoration-none" to="/digital-assets-management/folder/add">
            <BtnAdd addEditAccess={damAddEditAccess} />
          </Link>

          {damAddEditAccess && <BtnSelectAll handleSelectAll={handleSelectAll} isSelectAll={isSelectAll} isDisabled={state?.damFolderGroupList?.length <= 0} />}
        </div>
      </div>
      {state.activeList !== 'bin' && (
        <Container fluid className="d-flex flex-wrap justify-content-end my-2">
          <button onClick={() => onOpenClick()} type="button" className={`btn my-1 my-md-0 btn-page-filter ${state?.activeList === 'open' && btnActiveClass}`}>
            {t('DAM_MAIN_VIEW.LISTING_VIEW.OPEN_ASSET')}
          </button>
          <button
            onClick={() => onFolderClick()}
            type="button"
            className={`btn my-1 my-md-0 btn-page-filter ${state?.activeList === 'folder' && btnActiveClass}`}
          >
            {t('DAM_MAIN_VIEW.LISTING_VIEW.OPEN_FOLDER')}
          </button>
          <button
            type="button"
            className={`btn my-1 my-md-0 btn-page-filter ${state?.activeList === 'archived' && btnActiveClass}`}
            onClick={() => onArchivedAssetClick()}
          >
            {t('DAM_MAIN_VIEW.LISTING_VIEW.ARCHIVED_ASSET')}
          </button>
          <button
            type="button"
            className={`btn my-1 my-md-0 btn-page-filter ${state?.activeList === 'archivedFolder' && btnActiveClass}`}
            onClick={() => onArchivedFolderClick()}
          >
            {t('DAM_MAIN_VIEW.LISTING_VIEW.ARCHIVED_FOLDER')}
          </button>
        </Container>
      )}

      <div className="container-fluid my-3">
        <div className="">
          {!state.loading && state.damFolderGroupList.length === 0 && state.activeList === 'folder' && (
            <div className="w-100 text-center">
              <h6>{t('TAKING_DATES.NO_DATA_FOUND')}</h6>
            </div>
          )}
        </div>
      </div>

      {state?.activeList === 'folder' && (
        <InfiniteScroll
          dataLength={state.damFolderGroupList.length}
          next={() => handlePageNextInScroll()}
          hasMore={state.hasMore}
          loader={state.loading && <Loader />}
          scrollableTarget="scrollableDiv"
          className="fixed-col-container"
        >
          <div className="container-fluid my-3">
            <Row>
              {state?.damFolderGroupList?.map((item, i) => (
                <DamFolderGroupCard
                  key={item?._id}
                  item={item}
                  index={i}
                  onDelete={deleteDamFolderGroup}
                  onCheck={onSelectCheckBox}
                  selectedIds={selectedIdArray}
                  archiveUnArchivedFn={archiveUnArchivedFn}
                  damDeleteAccess={damDeleteAccess}
                  damAddEditAccess={damAddEditAccess}
                />
              ))}
            </Row>
          </div>
        </InfiniteScroll>
      )}
      {state?.activeList === 'archivedFolder' && <ArchivedFolder isSelectAll={isSelectAll} />}
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          message={selectedBomLibraryGroupId?.length > 0 ? t('DAM_MAIN_VIEW.LISTING_VIEW.DAM_DELETE_GROUP') : t('DAM_MAIN_VIEW.LISTING_VIEW.DAM_DELETE_GROUPS')}
          title="Delete"
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
        />
      )}
      {state?.activeList === 'bin' && <BinFolder />}
      {activeAcrhiveModal && (
        <ConfirmationPopup
          onOpen={activeAcrhiveModal}
          onConfirm={handleArchivedUnarchivedConfirmed}
          title={
            location?.state?.activeList === 'folder'
              ? t('DAM_FOLDER_VIEW.LISTING_VIEW.ACRHIVE_DAM_FOLDER_TITLE')
              : t('DAM_FOLDER_VIEW.LISTING_VIEW.UNACRHIVE_DAM_FOLDER_TITLE')
          }
          message={`${t('DAM_MAIN_VIEW.LISTING_VIEW.ARE_YOU_SURE_YOU_WANT_TO')} ${
            location?.state?.activeList === 'folder' ? t('DAM_MAIN_VIEW.LISTING_VIEW.ARCHIVE') : t('DAM_MAIN_VIEW.LISTING_VIEW.UNARCHIVE')
          } 
          ${
            selectedBomLibraryGroupId?.length > 0
              ? t('DAM_MAIN_VIEW.LISTING_VIEW.THE_SELECTED_DAM_FOLDER')
              : t('DAM_MAIN_VIEW.LISTING_VIEW.THE_SELECTED_DAM_FOLDERS')
          }
         `}
          toggle={closeAcrhiveTrashDeleteModal}
          isCommentOn
          comment={state?.archivedComment}
          commentText={(e) =>
            setState((prevState) => ({
              ...prevState,
              archivedComment: e.target.value,
            }))
          }
        />
      )}
    </>
  );
}

export default DamFolderList;
